// грузим набор длин паролей ... 
import {PROFILE_PASSWORD_MINLEN} from '../config/config';

// работа с текущим регионом 
import region from "../utils/region.js";

// запрос минимальной длины  пароля для текущего региона
const passLen = region.getRegionConfig(PROFILE_PASSWORD_MINLEN);

export default {
  methods: {
    compare (names = [], errors, msg = 'Пароли не совпадают. ') {
      let prev = null
      for (let i = 0; i < names.length; i++) {
        let name = names[i]
        if (!prev) {
          prev = this.fields[name]
        } else {
          if (prev !== this.fields[name]) {
            errors[name] = (errors[name] || '') + msg
            break
          }
          prev = this.fields[name]
        }
      }
    },
    minLen (names = [], errors, len = passLen) {
      names.forEach(name => {
        if (this.fields[name].length < len) {
          errors[name] = (errors[name] || '') + 'Минимальная длина ' + len + ' символов. '
        }
      })
    },
    checkRegExp (names = [], errors, condition, msg) {
      names.forEach(name => {
        let regExp = new RegExp(condition)
        if (!regExp.test(this.fields[name])) {
          errors[name] = (errors[name] || '') + msg
        }
      })
    }
  }
}
